/**
 * Script principal del sitio web de Fuigo
 * Inicializa el simulador y configura funcionalidades generales
 */

import { TransportSimulator } from './simulator.js';
import { MediaManager } from './utils.js';

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  // Inicializar simulador (demo que redirige a app.fuigo.co)
  new TransportSimulator('simulator-container');
  
  // Inicializar lazy loading para multimedia
  MediaManager.lazyLoad();
  
  // Smooth scroll para enlaces internos
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
  
  // Manejo de errores de video
  const heroVideo = document.querySelector('.hero-video');
  if (heroVideo) {
    heroVideo.addEventListener('error', function() {
      console.warn('Error cargando video, mostrando solo poster');
      this.style.display = 'none';
    });
  }
});
